import { combineReducers } from 'redux';
import selectShoesReducer from './selectShoesReducer';
import selectTopsReducer from './selectTopReducer';
import selectTrouserReducer from './selecTrouserReducer';
import userSelectReducer from './userReducer';


 

export default combineReducers({
    selectTopsReducer,
    selectTrouserReducer,
    selectShoesReducer,
    userSelectReducer
  })